import { ClientRouter as BifrostRouter } from "./router/ClientRouter";

export {
    BifrostRouter
}

export default BifrostRouter;

